import { action } from 'easy-peasy';
import { IActionSetMoreTemplates } from '../types';

const setMoreTemplates: IActionSetMoreTemplates = action((state, payload) => {
  const hasMore = state.pagination.itemsPerPage === payload.length;

  state.items = [...state.items, ...payload];
  state.pagination.page += 1;
  state.pagination.hasMore = hasMore;
});

export default setMoreTemplates;
